export default __webpack_public_path__ + "static/media/Ballroll_00322.01d7fffb.png";